export const images = {
    //loading
    logo_zalopay: `${window['runtime_configs'].PUBLIC_URL}/images/zlp-v2-logo.svg`,
    //home
    home_bg: `${window['runtime_configs'].PUBLIC_URL}/images/home-header.png`,
    home_product: `${window['runtime_configs'].PUBLIC_URL}/images/home-product.png`,
    home_policy_icon: `${window['runtime_configs'].PUBLIC_URL}/images/home-policy-icon.svg`,
    home_ft_left_icon: `${window['runtime_configs'].PUBLIC_URL}/images/home-ft-left-icon.svg`,
    home_ft_right_icon: `${window['runtime_configs'].PUBLIC_URL}/images/home-ft-right-icon.svg`,

    home_toolip_content: `${window['runtime_configs'].PUBLIC_URL}/images/home-help-tooltip.png`,
    home_toolip_narrow: `${window['runtime_configs'].PUBLIC_URL}/images/home-help-tooltip-narrow.png`,
}
